import React, { useContext, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import Slider from "react-slick";
import { api_url, backend_domain } from "../helpers";
import { userContext } from "../context/UserContext";
import RelatedProductsCard from "../component/RelatedProductsCard";
import ReactHtmlParser from 'react-html-parser'

const SingleProduct = () => {
  const { user, setLoad, cartUpdate } = useContext(userContext);
  const [currentQty, setCurrentQty] = useState(0);
  const [singleProduct, setSingleProduct] = useState([]);

  function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  const item_code = useQuery().get("id");

  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
      <button
        type="button"
        onClick={onClick}
        className={` ${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-right" />
      </button>
    );
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;

    return (
      <button
        type="button"
        onClick={onClick}
        className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
      >
        <i className="ph ph-caret-left" />
      </button>
    );
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    slidesToShow: 6,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1599,
        settings: {
          slidesToShow: 6,
        },
      },
      {
        breakpoint: 1399,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 424,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  async function SingleProductData() {
    setLoad(true);

    let main_url =
      api_url +
      `method/erp_sn.api.related_item.get_item_detail_and_related?item_code=${item_code}`;

    if (user?.name != "guest") {
      main_url = main_url + `&email=${user?.email}`;
    }

    const responsData = await fetch(main_url, {
      headers: {
        Authorization: `token ${user?.api_key}:${user?.api_secret}`,
      },
    });

    if (responsData.ok == true) {
      const data = await responsData.json();
      console.log(data);
      setSingleProduct(data?.message);

      if (user?.name != "guest") {
        setCurrentQty(
          data?.message?.item?.sales_order_info?.exists
            ? data?.message?.item?.sales_order_info?.qty
            : 0
        );
      }
    }

    setTimeout(() => {
      setLoad(false);
    }, 300);
  }

  useEffect(() => {
    SingleProductData();
  }, []);

  return (
    <section className="product-details py-80">
      <div className="container container-lg">
        <div className="row gy-4">
          <div className="col-xl-9">
            <div className="row gy-4">
              <div className="col-xl-6">
                <div className="product-details__left">
                  <div
                    className="product-details__thumb-slider border border-gray-100 rounded-16"
                    style={{ minWidth: "300px" }}
                  >
                    <div className="">
                      <div className="product-details__thumb flex-center h-100">
                        <img
                          src={`${backend_domain}${singleProduct?.item?.images[0]}`}
                          alt="Main Product"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="mt-24"></div>
                </div>
              </div>
              <div className="col-xl-6">
                <div className="product-details__content">
                  <h5 className="mb-12">{singleProduct?.item?.item_name}</h5>

                  <span className="text-gray-900">
                    <span className="text-gray-400">
                      {singleProduct?.item?.item_code}
                    </span>
                  </span>
                  <span className="mt-32 pt-32 text-gray-700 border-top border-gray-100 d-block" />
                  <p className="text-gray-700">
                    {ReactHtmlParser(singleProduct?.item?.description)}
                    
                  </p>
                  <div className="my-32 flex-align gap-16 flex-wrap">
                    <div className="flex-align gap-8">
                      <h5 className="mb-0">
                        {`${singleProduct?.item?.prices[0]?.rate} KD`}
                      </h5>
                    </div>
                  </div>
                  <hr />
                  {user?.name == "guest" ? (
                    <Link
                      to={user?.name == "guest" ? "/login" : "/cart"}
                      className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-48"
                    >
                      <i className="ph ph-shopping-cart-simple text-lg" />
                      Add To Cart
                    </Link>
                  ) : currentQty > 0 ? (
                    <>
                      <div className="d-flex rounded-4 overflow-hidden">
                        <button
                          type="button"
                          className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                          onClick={() => {
                            setCurrentQty(currentQty - 1);

                            cartUpdate({
                              item_code: singleProduct?.item?.item_code,
                              qty: currentQty - 1,
                              rate: singleProduct?.item?.prices[0]?.rate,
                            });
                          }}
                        >
                          <i className="ph ph-minus" />
                        </button>
                        <input
                          type="number"
                          className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                          id="stock"
                          readOnly
                          value={currentQty}
                        />
                        <button
                          type="button"
                          onClick={() => {
                            setCurrentQty(currentQty + 1);

                            cartUpdate({
                              item_code: singleProduct?.item?.item_code,
                              qty: currentQty + 1,
                              rate: singleProduct?.item?.prices[0]?.rate,
                            });
                          }}
                          className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                        >
                          <i className="ph ph-plus" />
                        </button>
                      </div>
                    </>
                  ) : (
                    <button
                      onClick={() => {
                        cartUpdate({
                          item_code: singleProduct?.item?.item_code,
                          qty: 1.0,
                          rate: singleProduct?.item?.prices[0]?.rate,
                        });
                        setCurrentQty(1);
                      }}
                      className="btn btn-main flex-center gap-8 rounded-8 py-16 fw-normal mt-48"
                    >
                      <i className="ph ph-shopping-cart-simple text-lg" />
                      Add To Cart
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="col-xl-3">
            <div className="product-details__sidebar py-40 px-32 border border-gray-100 rounded-16">
              <div className="mb-32">
                <label
                  htmlFor="delivery"
                  className="h6 activePage mb-8 text-heading fw-semibold d-block"
                >
                  Delivery
                </label>
                <div className="flex-align border border-gray-100 rounded-4 px-16">
                  <span className="text-xl d-flex text-main-600">
                    <i className="ph ph-map-pin" />
                  </span>
                  <select
                    defaultValue={1}
                    className="common-input border-0 px-8 rounded-4"
                    id="delivery"
                  >
                    <option value={1}>Maymansign</option>
                    <option value={1}>Khulna</option>
                    <option value={1}>Rajshahi</option>
                    <option value={1}>Rangpur</option>
                  </select>
                </div>
              </div>
              <div className="mb-32">
                <label
                  htmlFor="stock"
                  className="text-lg mb-8 text-heading fw-semibold d-block"
                >
                  Total Stock: 21
                </label>
                <span className="text-xl d-flex">
                  <i className="ph ph-location" />
                </span>
                <div className="d-flex rounded-4 overflow-hidden">
                  <button
                    type="button"
                    className="quantity__minus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph ph-minus" />
                  </button>
                  <input
                    type="number"
                    className="quantity__input flex-grow-1 border border-gray-100 border-start-0 border-end-0 text-center w-32 px-16"
                    id="stock"
                    readOnly
                  />
                  <button
                    type="button"
                    className="quantity__plus flex-shrink-0 h-48 w-48 text-neutral-600 bg-gray-50 flex-center hover-bg-main-600 hover-text-white"
                  >
                    <i className="ph ph-plus" />
                  </button>
                </div>
              </div>
              <div className="mb-32">
                <div className="flex-between flex-wrap gap-8 border-bottom border-gray-100 pb-16 mb-16">
                  <span className="text-gray-500">Price</span>
                  <h6 className="text-lg mb-0">$150.00</h6>
                </div>
                <div className="flex-between flex-wrap gap-8">
                  <span className="text-gray-500">Shipping</span>
                  <h6 className="text-lg mb-0">From $10.00</h6>
                </div>
              </div>
              <div className="mt-32">
                <div className="px-16 py-8 bg-main-50 rounded-8 flex-between gap-24 mb-14">
                  <span className="w-32 h-32 bg-white text-main-600 rounded-circle flex-center text-xl flex-shrink-0">
                    <i className="ph-fill ph-truck" />
                  </span>
                  <span className="text-sm text-neutral-600">
                    Ship from <span className="fw-semibold">MarketPro</span>{" "}
                  </span>
                </div>
                <div className="px-16 py-8 bg-main-50 rounded-8 flex-between gap-24 mb-0">
                  <span className="w-32 h-32 bg-white text-main-600 rounded-circle flex-center text-xl flex-shrink-0">
                    <i className="ph-fill ph-storefront" />
                  </span>
                  <span className="text-sm text-neutral-600">
                    Sold by:{" "}
                    <span className="fw-semibold">MR Distribution LLC</span>{" "}
                  </span>
                </div>
              </div>
              <div className="mt-32">
                <div className="px-32 py-16 rounded-8 border border-gray-100 flex-between gap-8">
                  <Link to="#" className="d-flex text-main-600 text-28">
                    <i className="ph-fill ph-chats-teardrop" />
                  </Link>
                  <span className="h-26 border border-gray-100" />
                  <div className="dropdown on-hover-item">
                    <button
                      className="d-flex text-main-600 text-28"
                      type="button"
                    >
                      <i className="ph-fill ph-share-network" />
                    </button>
                    <div className="on-hover-dropdown common-dropdown border-0 inset-inline-start-auto inset-inline-end-0">
                      <ul className="flex-align gap-16">
                        <li>
                          <Link
                            to="/https://www.facebook.com"
                            className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                          >
                            <i className="ph-fill ph-facebook-logo" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/https://www.twitter.com"
                            className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                          >
                            <i className="ph-fill ph-twitter-logo" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/https://www.linkedin.com"
                            className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                          >
                            <i className="ph-fill ph-instagram-logo" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="/https://www.pinterest.com"
                            className="w-44 h-44 flex-center bg-main-100 text-main-600 text-xl rounded-circle hover-bg-main-600 hover-text-white"
                          >
                            <i className="ph-fill ph-linkedin-logo" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="pt-80">
          <div className="product-dContent border rounded-24">
            <div className="product-dContent__header border-bottom border-gray-100 flex-between flex-wrap gap-16">
              <ul
                className="nav common-tab nav-pills mb-3"
                id="pills-tab"
                role="tablist"
              >
                <li className="nav-item" role="presentation">
                  <button
                    className="nav-link active"
                    id="pills-description-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-description"
                    type="button"
                    role="tab"
                    aria-controls="pills-description"
                    aria-selected="true"
                  >
                    Description
                  </button>
                </li>
              </ul>
            </div>
            <div className="product-dContent__box">
              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-description"
                  role="tabpanel"
                  aria-labelledby="pills-description-tab"
                  tabIndex={0}
                >
                  <div className="mb-40">
                    <h6 className="mb-24">Product Description</h6>
                    <p>{ReactHtmlParser(singleProduct?.item?.description)}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <section className="organic-food py-80">
        <div className="container container-lg">
          <div className="section-heading">
            <div className="flex-between flex-wrap gap-8">
              <h5 className="mb-0">You Might Like Also </h5>
              <div className="flex-align mr-point gap-16">
                <Link
                  to="/shop"
                  className="text-sm fw-medium text-gray-700 hover-text-main-600 hover-text-decoration-underline"
                >
                  All Categories
                </Link>
              </div>
            </div>
          </div>
          <div className="organic-food__slider arrow-style-two">
            <Slider {...settings}>
              {singleProduct?.related_items?.length > 0 &&
                singleProduct?.related_items?.map(
                  (related_item, related_item_index) => {
                    return (
                      <RelatedProductsCard
                        key={related_item_index}
                        related_item={related_item}
                        user={user}
                        cartUpdate={cartUpdate}
                      />
                    );
                  }
                )}
            </Slider>
          </div>
        </div>
      </section>
    </section>
  );
};

export default SingleProduct;
